export const LanguageIcon = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 3.73529H8.07353M6.33824 2V3.73529C6.33824 7.56856 4.39557 10.6765 2 10.6765M2.86765 7.20588C2.86765 9.06612 5.42894 10.5966 8.68088 10.6765M8.94118 16.75L12.4118 8.94118L15.8824 16.75M15.1015 15.0147H9.72205"
        stroke="#525866"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
